// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#messageReactionIconContainer{\n  margin-bottom: 1.5px;\n}\n#messageReactionIcon {\n  display: none;\n  color: #999;\n  z-index: 10;\n  background-color: inherit;\n\n}\n#messageReactionIconContainer:hover #messageReactionIcon {\n  background-color: inherit;\n  display: block;\n}", ""]);
// Exports
module.exports = exports;
